/**
 * Mascaras de digitacao dos codigos fiscais (so reescrevem caracteres: sem validacao, que e do contrato `novoItemTributoSchema`).
 * O contrato aceita pontuacao e normaliza para so digitos; a tela grava so digitos.
 */

/** Grupos de digitos de cada codigo: NCM 4.2.2 (8), CEST 2.3.2 (7), NBS 1.4.2.2 (9). */
export const GRUPOS = {
  ncm: [4, 2, 2],
  cest: [2, 3, 2],
  nbs: [1, 4, 2, 2],
} as const;

/** Digitos do campo com a pontuacao do grupo ("40169300" -> "4016.93.00"). Corta no tamanho maximo do codigo. */
export function mascaraFiscal(valor: string, grupos: readonly number[]): string {
  const total = grupos.reduce((a, b) => a + b, 0);
  const digitos = valor.replace(/\D/g, '').slice(0, total);
  const partes: string[] = [];
  let pos = 0;
  for (const g of grupos) {
    const parte = digitos.slice(pos, pos + g);
    if (parte === '') break;
    partes.push(parte);
    pos += g;
  }
  return partes.join('.');
}

/** Somente digitos, com no maximo `n` (CST IBS/CBS = 3, cClassTrib = 6). */
export function apenasDigitos(valor: string, n: number): string {
  return valor.replace(/\D/g, '').slice(0, n);
}
